import { Validators } from "@angular/forms";
import { IFormKey } from "src/app/modules/shared/models/forms";
import moment = require("moment");

export const premium_payment_form_group_config: IFormKey[] = [
  {
    id: 'effect-date-field',
    label: 'Data Effetto Variazione',
    controlName: 'scheduleDate',
    css: 'col-4',
    type: 'DATEPICKER',
    minDate: moment()
  }
]

export const premium_payment_reactivation_form_template = {
    scheduleDate: moment()
}

export const premium_payment_reactivation_form_validators = {
    scheduleDate: [Validators.required]
}

export interface IRiattivazionePagamentiRequest {
    policyNumber: string;
    frequency?: string;
    importo?: string;
    scheduleDate?: string
}
